import { gallerySectionEnerSol } from "data/gallerySection";
import useActive from "hooks/useActive";
import Link from "next/link";
import React, { useState } from "react";
// import Masonry from "react-masonry-component";
import GalleryItem from "./GalleryItem";
import { Box, ImageList } from "@mui/material";
import MansonryLoader from "components/MansonryLoader/MansonryLoader";
import { useAppStore } from "lib/store";

const masonryOptions = {
  transitionDuration: 500,
};

const { title, tabBtns, items } = gallerySectionEnerSol;

const getCurrentItems = (current = "") =>
  items.filter((it) => it.filter.includes(current));

const getCount = (current = "") => getCurrentItems(current).length;

const GallerySectionEnergySol = ({ portfolio = false, similar = false }) => {
  const [current, setCurrent] = useState("all");
  const currentItems = getCurrentItems(current);
  const ref = useActive("#portfolio");
  const { loading, error, energySolutions } = useAppStore();

  return (
    <section
      ref={ref}
      className={`gallery-section${similar ? " similar-gallery" : ""}`}
      id="portfolio"
    >
      <div className="auto-container">
        <div className="sec-title centered">
          <h2>
            Our Work
            <span className="dot">.</span>
          </h2>
        </div>
        <div className="mixitup-gallery">
        <Box sx={{ width: '100%', height: 450, overflowY: 'scroll' }}>
            <ImageList variant="masonry" cols={3} gap={8}>
              {Array(energySolutions.total).fill(0).slice(0, Array(energySolutions.total).length).map((item, index) => (
                index != 0 && <MansonryLoader
                  key={`${energySolutions.title}-${index}`}
                  title={energySolutions.title}
                  count={index}
                  path={energySolutions.path}
                  alt='Energy-Solutions' />
              ))}
            </ImageList>
          </Box>
        </div>
      </div>
    </section>
  );
};

export default GallerySectionEnergySol;
